import moment from "moment";

export const imcCalculator = (form, inputs, setImcDecimal) => {
  let heightInput = inputs.measurements.find((measurement) => measurement.name === 'Talla');
  let weightInput = inputs.measurements.find((measurement) => measurement.name === 'Peso');

  if (heightInput && weightInput && form.getFieldValue('measurements')) {
    let imcInput = inputs.procedures.find((procedure) => procedure.name === 'IMC');

    const height = form.getFieldValue('measurements')[heightInput.id.toString()];
    const weight = form.getFieldValue('measurements')[weightInput.id.toString()];

    if (weight && height && /-?.?\d+$/.test(weight) && /-?.?\d+$/.test(height)) {
      const reducedHeight = parseFloat(height) / 100;
      const imc = (parseFloat(weight) / Math.pow(reducedHeight, 2)).toFixed(setImcDecimal);
      const field = { procedures: {} };
      field.procedures[imcInput.id] = imc;
      form.setFieldsValue(field);
    }
  }
};

export const pamCalculator = (form, inputs) => {
  let pasInput = inputs.measurements.find((measurement) => measurement.name === 'PAS');
  let padInput = inputs.measurements.find((measurement) => measurement.name === 'PAD');

  if (pasInput && padInput && form.getFieldValue('measurements')) {
    let pamInput = inputs.procedures.find((procedure) => procedure.name === 'PAM');

    const pas = form.getFieldValue('measurements')[pasInput.id.toString()];
    const pad = form.getFieldValue('measurements')[padInput.id.toString()];

    if (pas && pad && /-?.?\d+$/.test(pas) && /-?.?\d+$/.test(pad)) {
      const pam = ((2 * parseFloat(pad) + parseFloat(pas)) / 3).toFixed(2);
      const field = { procedures: {} };
      field.procedures[pamInput.id] = pam;
      form.setFieldsValue(field);
    }
  }
};

export const arterialPresionCalculator = (form, inputs) => {
  const pas1Input = inputs.measurements.find((measurement) => measurement.code === 'PAS1');
  const pas2Input = inputs.measurements.find((measurement) => measurement.code === 'PAS2');

  if (pas1Input && pas2Input && form.getFieldValue('measurements')) {
    const pasProdInput = inputs.procedures.find((procedure) => procedure.code === 'PROD_PAS');

    const pas = form.getFieldValue('measurements')[pas1Input.id.toString()];
    const pas2 = form.getFieldValue('measurements')[pas2Input.id.toString()];

    if (pas && pas2 && /-?.?\d+$/.test(pas) && /-?.?\d+$/.test(pas2)) {
      const field = { procedures: {} };
      field.procedures[pasProdInput.id] = (pas + pas2) / 2;
      form.setFieldsValue(field);
    }
  }
};

export const arterialWaistHipCalculators = (form, inputs) => {
  const cc1Input = inputs.measurements.find((measurement) => measurement.code === 'CC1');
  const cc2Input = inputs.measurements.find((measurement) => measurement.code === 'CC2');

  if (cc1Input && cc2Input && form.getFieldValue('measurements')) {
    const pasProdInput = inputs.procedures.find((procedure) => procedure.code === 'PROD_CC');

    const cc1 = form.getFieldValue('measurements')[cc1Input.id.toString()];
    const cc2 = form.getFieldValue('measurements')[cc2Input.id.toString()];

    if (cc1 && cc2 && /-?.?\d+$/.test(cc1) && /-?.?\d+$/.test(cc2)) {
      const field = { procedures: {} };
      field.procedures[pasProdInput.id] = (cc1 + cc2) / 2;
      form.setFieldsValue(field);
    }
  }
};

export const nutritionalDiagnosis = (form, inputs) => {
  const imcInput = inputs.procedures.find(procedure => procedure.code === 'IMC_1_ANTROPOMETRIA');
  if (imcInput) {
    const imc = form.getFieldValue('procedures')[imcInput.id.toString()];
    const nutritionalDiagnosis = inputs.procedures.find(procedure => procedure.code?.includes('DIAGNOSTICO_NUTRICIONAL'));
    const field = { procedures: {} };
    if (nutritionalDiagnosis) {
      if (imc < 18.49) {
        field.procedures[nutritionalDiagnosis.id] = 'Bajo peso: IMC < 18.4';
      } else if (imc >= 18.5 && imc <= 24.9) {
        field.procedures[nutritionalDiagnosis.id] = 'Normopeso: IMC 18.5 a 24.9';
      } else if (imc >= 25 && imc <= 29.9) {
        field.procedures[nutritionalDiagnosis.id] = 'Sobrepeso: IMC 25 - 29.9';
      } else if (imc >= 30 && imc <= 34.9) {
        field.procedures[nutritionalDiagnosis.id] = 'Obesidad I: IMC 30 - 34.9';
      } else if (imc >= 35 && imc <= 39.9) {
        field.procedures[nutritionalDiagnosis.id] = 'Obesidad II: IMC  35 - 39.9';
      } else if (imc >= 40) {
        field.procedures[nutritionalDiagnosis.id] = 'Obesidad III: IMC >= 40';
      } else {
        field.procedures[nutritionalDiagnosis.id] = '';
      }
    }
    form.setFieldsValue(field);
  }
};

export const bloodPressureDiagnosis = (form, inputs) => {
  const pasInput = inputs.measurements.find(measurement => measurement.code?.includes('PAS_1_ANTROPOMETRIA'));
  const padInput = inputs.measurements.find(measurement => measurement.code?.includes('PAD_1_ANTROPOMETRIA'));
  if (pasInput && padInput) {
    const pas = form.getFieldValue('measurements')[pasInput.id.toString()];
    const pad = form.getFieldValue('measurements')[padInput.id.toString()];
    const bloodPressureDiagnosis = inputs.procedures.find((procedure) => procedure.code?.includes('BLOOD_PRESSURE_DIAGNOSIS'));
    const field = { procedures: {} };
    if (bloodPressureDiagnosis) {
      if (pas < 90 && pad < 60) {
        field.procedures[bloodPressureDiagnosis.id] = 'HIPOTENSIÓN';
      } else if (pas >= 90 && pas <= 120 && pad >= 60 && pad <= 80) {
        field.procedures[bloodPressureDiagnosis.id] = 'NORMOTENSO SIN HTA';
      } else if (pas > 120 && pas < 130 && pad > 80 && pad <= 90) {
        field.procedures[bloodPressureDiagnosis.id] = 'ELEVADA SIN HTA';
      } else if (pas >= 130 && pad >= 90) {
        field.procedures[bloodPressureDiagnosis.id] = 'HTA ELEVADA (NECESITA INTERCONSULTA CON CARDIOLOGÍA)';
      } else {
        field.procedures[bloodPressureDiagnosis.id] = '';
      }
    }
    form.setFieldsValue(field);
  }
};

export const packsPerYearCalculator = (form, inputs) => {
  const findQuestion = (prefix) => 
    inputs.questions.find((question) => question?.code?.startsWith(prefix));

  const cigarettesInput = findQuestion('CIGARROS_DIA');
  const yearsInput = findQuestion('AÑOS_FUMANDO');

  if (cigarettesInput && yearsInput && form.getFieldValue('questions')) {
    const packsYearInput = findQuestion('PAQUETES_AÑO');

    const cigarettes = form.getFieldValue('questions')[cigarettesInput.id.toString()];
    const years = form.getFieldValue('questions')[yearsInput.id.toString()];

    if (cigarettes && years && /-?.?\d+$/.test(cigarettes) && /-?.?\d+$/.test(years)) {
      const packsYear = ((parseFloat(cigarettes) * parseFloat(years)) / 20).toFixed(2);
      const field = { questions: {} };
      if (packsYearInput) {
        field.questions[packsYearInput.id] = packsYear;
        form.setFieldsValue(field);
      }
    }
  }
};

export const bussPerryInterpretation = (form, inputs) => {
  const bussPerryResultProcedureInput = inputs.procedures.find((procedures) => procedures.code === 'BUSSPERRYRESULT');
  const bussPerryInterpretationProcedureInput = inputs.procedures.find((procedures) => procedures.code === 'BUSSPERRYINTERPRETATION');
  if (bussPerryResultProcedureInput && bussPerryInterpretationProcedureInput) {
    const bussPerryResultProcedure = form.getFieldValue('procedures')?.[bussPerryResultProcedureInput.id.toString()];
    const field = { procedures: {} };
    if (bussPerryResultProcedure) {
      if (bussPerryResultProcedure === 'Aprueba') {
        field.procedures[bussPerryInterpretationProcedureInput.id] =
          'Los resultados del examen se encuentran en parámetros normales, lo cual es compatible con las exigencias del cargo. Este perfil sugiere que el candidato posee la asertividad y la capacidad de respuesta necesarias para el rol de Vigilante Privado, sin que ello represente un riesgo de descontrol y agresividad sin justificación.';
      } else if (bussPerryResultProcedure === 'No Aprueba - Nivel agresividad muy bajo') {
        field.procedures[bussPerryInterpretationProcedureInput.id] =
          'La puntuación total sugiere un nivel de agresión muy bajo, lo que podría indicar una falta de asertividad y la capacidad para reaccionar con la firmeza necesaria en situaciones de riesgo. Este perfil compromete la capacidad del candidato para protegerse a sí mismo y a terceros.'
      } else if (bussPerryResultProcedure === 'No Aprueba - Nivel agresividad muy alto') {
        field.procedures[bussPerryInterpretationProcedureInput.id] =
          'La puntuación total corresponde a un nivel de agresión muy alto. Este perfil indica un riesgo significativo de respuestas agresivas desproporcionadas e incontroladas. El candidato no presenta las cualidades necesarias para un manejo seguro del rol de vigilancia y el arma de fuego.'
      } else {
        field.procedures[bussPerryInterpretationProcedureInput.id] = '';
      }
    }
    form.setFieldsValue(field);
  }
};

export const iccCalculator = (form, inputs) => {
  const waistInput = inputs.measurements?.find((measurement) => measurement.code === 'PERIMETRO_CINTURA_1_ANTROPOMETRIA');
  const hipInput = inputs.measurements?.find((measurement) => measurement.code === 'PERIMETRO_CADERA_1_ANTROPOMETRIA');

  if (waistInput && hipInput && form.getFieldValue('measurements')) {
    const iccInput = inputs.procedures?.find((procedure) => procedure.code === 'ICC_1_ANTROPOMETRIA');

    if (iccInput) {
      const waist = form.getFieldValue('measurements')[waistInput.id.toString()];
      const hip = form.getFieldValue('measurements')[hipInput.id.toString()];

      if (waist && hip && /-?.?\d+$/.test(waist) && /-?.?\d+$/.test(hip)) {
        const waistValue = parseFloat(waist);
        const hipValue = parseFloat(hip);

        if (hipValue > 0) {
          const icc = (waistValue / hipValue).toFixed(2);
          const field = { procedures: {} };
          field.procedures[iccInput.id] = icc;
          form.setFieldsValue(field);
          return { calculatedFieldId: iccInput.id, calculatedFieldCode: iccInput.code };
        }
      }

      return { calculatedFieldId: iccInput.id, shouldRemove: true };
    }
  }

  return null;
};

const syncQuestions = (form, inputs, config) => {
  const { 
    targetCodes, 
    parentCode, 
    secondaryParentCode, 
    changedItem, 
    changedValue,
    onHasYes
  } = config;

  const { questions = [] } = inputs;
  const currentFormValues = form.getFieldValue('questions') || {};
  const getVal = (question) => (changedItem?.id === question.id ? changedValue : currentFormValues[question.id]);

  const targetQuestions = questions.filter(question => targetCodes.includes(question.code));
  const parentQuestion = questions.find(question => question.code === parentCode);
  const secondaryQuestion = secondaryParentCode ? questions.find(question => question.code === secondaryParentCode) : null;

  if (!targetQuestions.length || !parentQuestion) return;

  const values = targetQuestions.map(question => getVal(question));
  const hasYes = values.includes('si');
  const allNo = values.every(v => v === 'no');

  const updates = {};

  if (hasYes) {
    if (getVal(parentQuestion) !== 'si') updates[parentQuestion.id] = 'si';
    if (onHasYes) Object.assign(updates, onHasYes(targetQuestions, getVal));
  } else if (allNo) {
    if (getVal(parentQuestion) !== 'no') updates[parentQuestion.id] = 'no';
    if (secondaryQuestion && getVal(secondaryQuestion) !== (config.secondaryDefault || 'no')) {
      updates[secondaryQuestion.id] = config.secondaryDefault || 'no';
    }
  }

  if (Object.keys(updates).length > 0) {
    form.setFieldsValue({ questions: updates });
  }
};

export const heartDiseasesCalculator = (form, inputs, changedItem, changedValue) => {
  syncQuestions(form, inputs, {
    changedItem,
    changedValue,
    parentCode: 'ENFERMEDADES_CORAZON_ANTECEDENTES_CARDIACOS_DECLARACION_SALUD_ISL_ANEXO13',
    secondaryParentCode: 'ENFERMEDADES_CORAZON_TRATAMIENTO_ANTECEDENTES_CARDIACOS_DECLARACION_SALUD_ISL_ANEXO13',
    targetCodes: [  
      'INFARTO_DECLARACION_SALUD_ISL', 'MARCAPASOS_DECLARACION_SALUD_ISL',
      'ARRITMIA_DECLARACION_SALUD_ISL', 'VALVULOPATIAS_CARDIACAS_DECLARACION_SALUD_ISL',
      'CARDIOPATIAS_CONGENITAS_DECLARACION_SALUD_ISL', 'TRANSPLANTE_CARDIACO_DECLARACION_SALUD_ISL',
      'OTRAS_ENFERMEDADES_CORAZON_DECLARACION_SALUD_ISL'
    ]
  });
};

export const lungDiseasesCalculator = (form, inputs, changedItem, changedValue) => {
  const whichDiseasesCode = 'ENFERMEDADES_RESPIRATORIAS_CUAL_2_ANTECEDENTES_RESPIRATORIOS_DECLARACION_SALUD_ISL_ANEXO13';
  const otherDescCode = 'OTRAS_ENFERMEDADES_PULMONES_DESCRIPCION_ANTECEDENTES_RESPIRATORIOS_DECLARACION_SALUD_ISL';

  const whichDiseasesQuestion = inputs.questions?.find(question => question.code === whichDiseasesCode);
  if (changedItem?.id === whichDiseasesQuestion?.id) return;

  syncQuestions(form, inputs, {
    changedItem,
    changedValue,
    parentCode: 'ENFERMEDADES_RESPIRATORIAS_1_ANTECEDENTES_RESPIRATORIOS_DECLARACION_SALUD_ISL_ANEXO13',
    secondaryParentCode: whichDiseasesCode,
    secondaryDefault: '',
    targetCodes: [
      'ASMA_ANTECEDENTES_RESPIRATORIOS_DECLARACION_SALUD_ISL', 'BRONQUITIS_CRONICA_ANTECEDENTES_RESPIRATORIOS_DECLARACION_SALUD_ISL',
      'EPOC_ANTECEDENTES_RESPIRATORIOS_DECLARACION_SALUD_ISL', 'NEUMOTORAX_ANTECEDENTES_RESPIRATORIOS_DECLARACION_SALUD_ISL',
      'HIPERTENSION_PULMONAR_ANTECEDENTES_RESPIRATORIOS_DECLARACION_SALUD_ISL', 'TRANSPLANTADO_PULMONAR_ANTECEDENTES_RESPIRATORIOS_DECLARACION_SALUD_ISL',
      'FISTULAS_ANTECEDENTES_RESPIRATORIOS_DECLARACION_SALUD_ISL', 'TROMBOEMBOLISMO_ANTECEDENTES_RESPIRATORIOS_DECLARACION_SALUD_ISL',
      'NEUMOPATIA_AGUDA_ANTECEDENTES_RESPIRATORIOS_DECLARACION_SALUD_ISL', 'SAHOS_ANTECEDENTES_RESPIRATORIOS_DECLARACION_SALUD_ISL',
      'MAL_MONTAÑA_EDEMA_ANTECEDENTES_RESPIRATORIOS_DECLARACION_SALUD_ISL', 'TUBERCULOSIS_ANTECEDENTES_RESPIRATORIOS_DECLARACION_SALUD_ISL',
      'OTRAS_ENFERMEDADES_PULMONES_ANTECEDENTES_RESPIRATORIOS_DECLARACION_SALUD_ISL'
    ],
    onHasYes: (targets, getVal) => {
      const list = targets
        .filter(q => getVal(q) === 'si' && q.code !== 'OTRAS_ENFERMEDADES_PULMONES_ANTECEDENTES_RESPIRATORIOS_DECLARACION_SALUD_ISL')
        .map(q => q.name.replace(/^[¿\s]+|[?\s]+$/g, ''));

      const otherDescQ = inputs.questions?.find(q => q.code === otherDescCode);
      const otherVal = otherDescQ ? getVal(otherDescQ) : null;
      if (otherVal?.trim()) list.push(otherVal.trim());

      const formattedWithAnd = list.length > 1 
        ? `${list.slice(0, -1).join(', ')} y ${list.slice(-1)}` 
        : list[0] || '';

      return { [whichDiseasesQuestion.id]: formattedWithAnd };
    }
  });
};

export const occupationalHistoryTimeCalculator = (form, inputs) => {
  const allFields = [...(inputs?.questions || [])];
  
  const startDates = allFields.filter(field => field.code?.toLowerCase().includes('startdate'));
  const endDates = allFields.filter(field => field.code?.toLowerCase().includes('enddate'));
  const totalTimes = allFields.filter(field => field.code?.toLowerCase().includes('totaltime'));

  const getJobId = (field) => {
    const match = field.code?.match(/(\d+)/);
    return match ? match[1] : (field.code || field.id.toString());
  };

  const startGroups = {};
  const endGroups = {};
  const totalGroups = {};

  if (startDates.length) startDates.forEach(field => startGroups[getJobId(field)] = field);
  if (endDates.length) endDates.forEach(field => endGroups[getJobId(field)] = field);
  if (totalTimes.length) totalTimes.forEach(field => totalGroups[getJobId(field)] = field);

  const finalResults = [];
  const fieldsToUpdate = { questions: {} };
  let hasUpdates = false;

  Object.keys(totalGroups).forEach(jobId => {
    const startDateInput = startGroups[jobId];
    const endDateInput = endGroups[jobId];
    const totalTimeInput = totalGroups[jobId];

    if (startDateInput && endDateInput && totalTimeInput) {
      const startDateRaw = form.getFieldValue('questions')?.[startDateInput.id.toString()];
      const endDateRaw = form.getFieldValue('questions')?.[endDateInput.id.toString()];

      if (startDateRaw && endDateRaw) {
        let startDateFormatted = moment(startDateRaw);
        let endDateFormatted = moment(endDateRaw);

        if (startDateFormatted.isValid() && endDateFormatted.isValid() && startDateFormatted.isSameOrBefore(endDateFormatted)) {
          const diffMonths = Math.abs(endDateFormatted.diff(startDateFormatted, 'months'));
          const years = Math.floor(diffMonths / 12);
          const months = diffMonths % 12;
          let totalTime = '';

          if (years > 0) totalTime += `${years} año${years > 1 ? 's' : ''}`;

          if (months > 0) {
            if (years > 0) totalTime += ' ';
            totalTime += `${months} mes${months > 1 ? 'es' : ''}`;
          }

          if (totalTime === '') totalTime = 'Menos de 1 mes';

          fieldsToUpdate['questions'][totalTimeInput.id.toString()] = totalTime;
          hasUpdates = true;
          finalResults.push({ calculatedFieldId: totalTimeInput.id });
          return;
        }
      }

      fieldsToUpdate['questions'][totalTimeInput.id.toString()] = '';
      hasUpdates = true;
      finalResults.push({ calculatedFieldId: totalTimeInput.id, shouldRemove: true });
    }
  });

  if (hasUpdates) {
    if (!Object.keys(fieldsToUpdate.questions).length) delete fieldsToUpdate.questions;
    form.setFieldsValue(fieldsToUpdate);
  }

  return finalResults.length ? finalResults : null;
};

export const simpleMusculoskeletalCalculator = (form, inputs, changedItem, changedValue) => {
  if (!inputs.questions) return;

  const currentFormValues = form.getFieldValue('questions') || {};

  const getVal = (question) => {
    if (changedItem && changedItem.id === question.id) {
      return changedValue;
    }
    return currentFormValues[question.id.toString()];
  };

  const backFitnessCodes = [
    'FLEXIBILIDAD_ABDOMEN_1_APTITUD_ESPALDA_MUSCULO_ESQUELETICO_SIMPLE',
    'CADERA_3_APTITUD_ESPALDA_MUSCULO_ESQUELETICO_SIMPLE',
    'MUSLO_5_APTITUD_ESPALDA_MUSCULO_ESQUELETICO_SIMPLE',
    'ABDOMEN_LATERAL_7_APTITUD_ESPALDA_MUSCULO_ESQUELETICO_SIMPLE',
  ];
  const backFitnessTotalCode = 'TOTAL_9_APTITUD_ESPALDA_MUSCULO_ESQUELETICO_SIMPLE';

  const jointRangesCodes = [
    'ABDUCACION_HOMBRO_0_180_1_RANGOS_ARTICULARES_MUSCULO_ESQUELETICO_SIMPLE',
    'ABDUCACION_HOMBRO_0_60_3_RANGOS_ARTICULARES_MUSCULO_ESQUELETICO_SIMPLE',
    'ROTACION_EXTERNA_5_RANGOS_ARTICULARES_MUSCULO_ESQUELETICO_SIMPLE',
    'ROTACION_INTERNA_7_RANGOS_ARTICULARES_MUSCULO_ESQUELETICO_SIMPLE',
  ];
  const jointRangesTotalCode = 'TOTAL_9_RANGOS_ARTICULARES_MUSCULO_ESQUELETICO_SIMPLE';

  const updates = {};

  const calculateSectionTotal = (codes, totalCode) => {
    let sum = 0;
    let hasValue = false;
    codes.forEach(code => {
      const question = inputs.questions.find(q => q.code === code);
      if (question) {
        const val = getVal(question);
        if (val && !isNaN(parseInt(val, 10))) {
          sum += parseInt(val, 10);
          hasValue = true;
        }
      }
    });

    if (hasValue) {
      const totalQuestion = inputs.questions.find(q => q.code === totalCode);
      if (totalQuestion) {
        if (getVal(totalQuestion) !== sum.toString()) {
          updates[totalQuestion.id.toString()] = sum.toString();
        }
      }
    }
  };

  calculateSectionTotal(backFitnessCodes, backFitnessTotalCode);
  calculateSectionTotal(jointRangesCodes, jointRangesTotalCode);

  if (Object.keys(updates).length > 0) {
    form.setFieldsValue({ questions: { ...currentFormValues, ...updates } });
  }
};

export const pathologicalDescriptionsCalculator = (form, inputs, changedItem, changedValue) => {
  const { questions = [] } = inputs;
  if (!questions.length) return;

  const currentValues = form.getFieldValue('questions') || {};

  const getQuestionValue = (question) =>
    changedItem?.id === question.id ? changedValue : currentValues[question.id.toString()];

  const diseasesQuestion = questions.find(question => question.code === 'ENFERMEDADES_1_PATOLOGICOS');
  if (!diseasesQuestion) return;
  const selectedDiseaseValue = getQuestionValue(diseasesQuestion);
  let selectedDiseases = [];
  if (Array.isArray(selectedDiseaseValue)) {
    selectedDiseases = selectedDiseaseValue;
  } else if (typeof selectedDiseaseValue === 'string' && selectedDiseaseValue.trim()) {
    selectedDiseases = selectedDiseaseValue.split(',').map(disease => disease.trim());
  }

  const visibilityRules = inputs?.form_layout?.logic?.visibility || [];
  const descriptions = questions
    .map(question => {
      if (!question.code || !question.code.endsWith('_DESCRIPCION_1_PATOLOGICOS') || question.code === 'DESCRIPCION_1_PATOLOGICOS') {
        return null;
      }
      const rule = visibilityRules.find(rule => rule.target?.code === question.code);
      if (!rule) return null;
      const condition = rule.conditions?.find(condition => condition.code === 'ENFERMEDADES_1_PATOLOGICOS');
      if (!condition || !condition.value) return null;
      const cleanDiseaseName = condition.value.trim();
      const isSelected = selectedDiseases.some(selected => selected.trim() === cleanDiseaseName);
      if (!isSelected) return null;

      const observation = (getQuestionValue(question) || "").trim();
      return observation ? `${cleanDiseaseName}: ${observation}` : null;
    })
    .filter(Boolean);

  const descriptionQuestion = questions.find(question => question.code === "DESCRIPCION_1_PATOLOGICOS");
  if (descriptionQuestion) {
    form.setFieldsValue({
      questions: {
        [descriptionQuestion.id.toString()]: descriptions.join(", ")
      }
    });
  }
};


